import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import { GOOGLE_AUTHENTICATOR, SMS, SECURITY_PHONE_NUMBER, HUBSPOT_AUTHENTICATOR } from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
import { trackTwoFactorSetup, TwoFactorAuthTypes, TwoFactorEventActions } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getStepName(method) {
  if (method === GOOGLE_AUTHENTICATOR) {
    return TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR;
  } else {
    return TwoFactorAuthSetupSteps.VERIFY_SMS;
  }
}
class VerifyAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sentAnother: false
    };
    this.handleVerificationCodeChange = this.handleVerificationCodeChange.bind(this);
    this.handleSendAnotherVerificationCode = this.handleSendAnotherVerificationCode.bind(this);
  }
  componentDidMount() {
    switch (this.props.method) {
      case TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR:
        trackTwoFactorSetup(TwoFactorAuthTypes.THIRD_PARTY_AUTHENTICATOR, TwoFactorEventActions.VERIFYING);
        break;
      case TwoFactorAuthMethods.SMS:
        trackTwoFactorSetup(TwoFactorAuthTypes.SMS_CODES, TwoFactorEventActions.VERIFYING);
        break;
      default:
    }
  }
  handleSendAnotherVerificationCode() {
    this.setState({
      sentAnother: true
    });
    this.props.resendSMSCode();
  }
  handleVerificationCodeChange(evt) {
    this.setState({
      sentAnother: false
    });
    this.props.onVerificationCodeChange(evt.target.value);
  }
  getHelpMessage() {
    if (this.state.sentAnother) {
      return I18n.text('userPreferences.2fa.newCodeSent');
    }
    if (getStepName(this.props.method) === TwoFactorAuthSetupSteps.VERIFY_SMS) {
      return /*#__PURE__*/_jsx(UIButton, {
        use: "link",
        onClick: this.handleSendAnotherVerificationCode,
        children: I18n.text('userPreferences.2fa.sendMeANewCode')
      });
    }
    return null;
  }
  render() {
    const {
      verificationCode,
      invalidVerificationCode,
      onKeyUp,
      method
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        paddingBlock: "700",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.2fa.${getStepName(method)}.contentTitle`
        })
      }), /*#__PURE__*/_jsx(UIFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsxs(UIBox, {
          basis: "400px",
          children: [/*#__PURE__*/_jsx(Text, {
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `userPreferences.2fa.${getStepName(method)}.description`
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "600"
          }), /*#__PURE__*/_jsx(UIForm, {
            children: /*#__PURE__*/_jsx(UIFormControl, {
              label: /*#__PURE__*/_jsx(UIFormLabel, {
                htmlFor: "code",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `userPreferences.2fa.${getStepName(method)}.codeInputLabel`
                })
              }),
              error: invalidVerificationCode,
              validationMessage: invalidVerificationCode && /*#__PURE__*/_jsx(Small, {
                use: "error",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `userPreferences.2fa.${getStepName(method)}.error`
                })
              }),
              help: this.getHelpMessage(),
              children: /*#__PURE__*/_jsx(UITextInput, {
                id: "code",
                value: verificationCode,
                onChange: this.handleVerificationCodeChange,
                onKeyUp: onKeyUp
              })
            })
          })]
        })
      })]
    });
  }
}
VerifyAuth.defaultProps = {
  resendSMSCode: emptyFunction.thatReturns
};
VerifyAuth.propTypes = {
  verificationCode: PropTypes.string.isRequired,
  invalidVerificationCode: PropTypes.bool.isRequired,
  method: PropTypes.oneOf([GOOGLE_AUTHENTICATOR, SMS, SECURITY_PHONE_NUMBER, HUBSPOT_AUTHENTICATOR]).isRequired,
  onKeyUp: PropTypes.func.isRequired,
  resendSMSCode: PropTypes.func.isRequired,
  onVerificationCodeChange: PropTypes.func.isRequired
};
export default VerifyAuth;